import { defineComponent as _defineComponent } from 'vue'
import { ObjectType, StreamingChartsTitlesEdge } from '@/@types/graphql-types';
import PictureComp from '@/components/picture/PictureComp.vue';
import SingleRankingDisplay from '@/components/streaming-charts/SingleRankingDisplay.vue';
import OffersDisplay from '@/components/streaming-charts/OffersDisplay.vue';
import StreamingChartsListItem from '@/components/streaming-charts/StreamingChartsListItem.vue';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { computed } from 'vue';
import { useI18n } from '@/helpers/composables/useI18n';

interface StreamingChartsListProps {
	titles: StreamingChartsTitlesEdge[];
	totalTitles: number | undefined;
	lastUpdated?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'StreamingChartsList',
  props: {
    titles: null,
    totalTitles: null,
    lastUpdated: null
  },
  setup(__props: any) {

const props = __props as { titles: StreamingChartsTitlesEdge[], totalTitles: number | undefined, lastUpdated?: string }

const { t } = useI18n();



const { country, language } = useLanguageStore();

const updatedTimestamp = computed(() => {
	if (!props.lastUpdated) {
		return null;
	}
	const date = new Date(props.lastUpdated).toLocaleDateString(`${language}-${country}`, {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
	});
	const time = new Date(props.lastUpdated).toLocaleTimeString(`${language}-${country}`);
	return `${time}, ${date}`;
});

return { __sfc: true,t, props, country, language, updatedTimestamp, StreamingChartsListItem }
}

})